(function() {
    'use strict';
    angular
        .module('mVtasWebApp')
        .factory('Ventames', Ventames);

    Ventames.$inject = ['$resource'];

    function Ventames ($resource) {
        var resourceUrl =  'api/ventames/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
